<template>
    <div id="signUp">
        <div v-if="!user">
            <h2> Signup </h2>
            <input type="text" name="" placeholder="Login" v-model="login"><br/>
            <input type="password" name="" placeholder="Password" v-model="password"><br/>
            <input type="email" name="" placeholder="Email" v-model="email"><br/>
            <button @click="submit">Submit</button>
        </div>

        <div v-if="user">
            <h2>Confirm Sign-up</h2>
            <input type="text" name="" placeholder="Input code" v-model="code"><br/>
            <button @click="confirm">Submit</button>
        </div>
    </div>
</template>

<script>
    import {AmplifyEventBus} from 'aws-amplify-vue'
    import Amplify, {Auth} from 'aws-amplify'

    export default {
        data() {
            return {
                email: '',
                login: '',
                password: '',
                code: '',
                user: ''
            }
        },
        methods: {
            submit() {
                Auth.signUp({
                    username: this.login,
                    password: this.password,
                    attributes: {
                        email: this.email,
                    },
                    validationData: [],
                })
                    .then(data => this.user = data.user)
                    .catch(err => console.log(err));
            },
            confirm() {
                Auth.confirmSignUp(this.login, this.code,
                    {
                        forceAliasCreation: true
                    })
                    .then(data => this.router.push("/"))
                    .catch(err => console.log(err))
            }
        }
    }
</script>

<style>

</style>
